import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";

export const createTaluka = createAsyncThunk(
  "Taluka/createTaluka",
  async (talukaData, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.post(
        "/v1/admin/taluka/create-taluka",
        talukaData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getTaluka = createAsyncThunk(
  "Taluka/getTaluka",
  async (
    {
      id,
      status = "All",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstanceJson.get(
        "/v1/admin/taluka/get-taluka",
        {
          params: {
            id,
            status,
            search,
            page,
            limit,
            startDate,
            endDate,
            paginate,
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const updatetaluka = createAsyncThunk(
  "Taluka/updateTaluka",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.put(
        `/v1/admin/taluka/update-taluka/${id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteTaluka = createAsyncThunk(
  "Taluka/deleteTaluka",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/taluka/delete-taluka/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const undoDeleteTaluka = createAsyncThunk(
  "Taluka/undoDeleteTaluka",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/taluka/undodelete-taluka/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getTalukaById = createAsyncThunk(
  "Taluka/getById",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/taluka/getSingle-taluka/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getDistictByTaluka = createAsyncThunk(
  "Taluka/getById",
  async (stateId, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/taluka/districtBy-taluka/${stateId}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getTalukaByDistrict = createAsyncThunk(
  "State/getById",
  async (districtId, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/taluka/districtBy-taluka/${districtId}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
